/* Commerce: toasts, scroll reveal, weight gauge, product page, AJAX add-to-cart.
   Ported from the mockup's app.js (sections 4, 6, 10, 11); the mockup's
   localStorage cart is replaced by Shopify's /cart.js, /cart/add.js, /cart/change.js.
   Every string that reaches innerHTML is either a literal in this file, a theme locale
   string (window.FR_STRINGS, rendered by the layout from locales/*.json), a number,
   or passes through esc().
   i18n: T(key, englishFallback, vars) reads window.FR_STRINGS[key] (locale key store.js.<key>)
   and fills {name} placeholders; with no FR_STRINGS the English fallback renders unchanged. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const T = (key, fallback, vars) => String((window.FR_STRINGS || {})[key] || fallback)
    .replace(/\{(\w+)\}/g, (m, n) => (vars && n in vars ? vars[n] : m));
  const money = cents => (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

  const LIMITS = { bulkKg: 50, warnKg: 45, bulkLb: 110 };
  const LIMIT_TEXT = '110 lb (50 kg)';
  const ICON = {
    check: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.5l4 4 8-9"/></svg>',
    warn: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M10 2.8L18.2 17H1.8L10 2.8z" stroke-linejoin="round"/><path d="M10 8v3.6M10 14v.2" stroke-linecap="round"/></svg>',
    stop: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="10" cy="10" r="8"/><path d="M6.8 6.8l6.4 6.4M13.2 6.8l-6.4 6.4" stroke-linecap="round"/></svg>'
  };

  /* ---------------------------------------------------------------- cart --- */
  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
  const addToCart = (id, quantity = 1) => fetch('/cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
  }).then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || T('err_add', 'Could not add to cart')); return j; });
  const changeLine = (line, quantity) => fetch('/cart/change.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ line, quantity })
  }).then(r => r.json());
  window.FR = { getCart, addToCart, changeLine, money, esc, T, ICON, LIMITS, LIMIT_TEXT };

  const paintCount = n => $$('.js-cart-count').forEach(el => {
    el.textContent = n; el.hidden = !n;
    if (n) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
  });
  window.FR.paintCount = paintCount;

  /* --------------------------------------------------------------- toast --- */
  function toast(message, href) {
    let region = $('#toasts');
    if (!region) {
      region = document.createElement('div');
      region.id = 'toasts'; region.className = 'toast-region';
      region.setAttribute('role', 'status'); region.setAttribute('aria-live', 'polite');
      document.body.append(region);
    }
    const el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = `${ICON.check}<span>${esc(message)}</span>${href ? `<a href="${href}">${esc(T('view_cart', 'View Cart'))}</a>` : ''}`;
    region.append(el);
    setTimeout(() => {
      el.classList.add('is-out');
      el.addEventListener('animationend', () => el.remove(), { once: true });
    }, 4200);
  }
  window.FR.toast = toast;

  /* --------------------------------------------------------------- gauge --- */
  function gaugeState(kg) { return kg >= LIMITS.bulkKg ? 'bulk' : kg >= LIMITS.warnKg ? 'warn' : 'ok'; }
  function renderGauge(root, grams) {
    const kg = grams / 1000, lb = kg / 0.45359237, state = gaugeState(kg);
    const pct = Math.min(100, (kg / LIMITS.bulkKg) * 100);
    root.dataset.state = state;
    const note = {
      ok: { icon: ICON.check, body: esc(T('gauge_ok', 'Standard checkout. Parcel shipping on orders up to {limit}.', { limit: LIMIT_TEXT })) },
      warn: { icon: ICON.warn, body: T('gauge_warn_html', 'You are approaching the Bulk Order threshold. Above {limit} you unlock volume pricing, LTL and pallet shipping — <a href="/pages/bulk-orders">see what changes</a>.', { limit: LIMIT_TEXT }) },
      bulk: { icon: ICON.stop, body: T('gauge_bulk_html', '<strong>Bulk Order required.</strong> Orders above {limit} ship by pallet or LTL and are priced by volume. <a href="/pages/bulk-orders">Request a Bulk Quote</a>.', { limit: LIMIT_TEXT }) }
    }[state];
    root.innerHTML = `
      <div class="gauge__head">
        <span class="gauge__value"><b class="num">${lb.toFixed(1)}</b> lb <span class="t-muted t-sm num">(${kg.toFixed(1)} kg)</span></span>
        <span class="gauge__limit num">${esc(T('gauge_limit', '{limit} online limit', { limit: LIMIT_TEXT }))}</span>
      </div>
      <div class="gauge__track" role="meter" aria-valuemin="0" aria-valuemax="${LIMITS.bulkKg}" aria-valuenow="${kg.toFixed(1)}"
           aria-label="${esc(T('gauge_aria', 'Order weight against the {kg} kilogram ({lb} pound) online limit', { kg: LIMITS.bulkKg, lb: LIMITS.bulkLb }))}">
        <div class="gauge__fill" style="width:${pct}%"></div><div class="gauge__notch"></div>
      </div>
      <p class="gauge__note">${note.icon}<span>${note.body}</span></p>`;
  }
  window.FR.renderGauge = renderGauge;
  window.FR.gaugeState = gaugeState;

  /* ------------------------------------------------------------- reveal --- */
  function initReveal() {
    const items = $$('[data-reveal], .origin-line > li');
    if (!items.length) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { items.forEach(el => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (!entry.isIntersecting) return; entry.target.classList.add('is-in'); io.unobserve(entry.target); });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(el => {
      const idx = [...el.parentElement.children].indexOf(el);
      el.style.setProperty('--reveal-delay', `${Math.min(idx, 6) * 65}ms`);
      io.observe(el);
    });
  }
  window.FR.initReveal = initReveal;

  /* ------------------------------------------------------- product page --- */
  function initProductPage() {
    const form = $('#buy-form');
    if (!form) return;
    const unitG = Number(form.dataset.weight) || 907;
    const unitCents = Number(form.dataset.price) || 0;
    const qtyInput = $('#buy-qty', form), priceEl = $('#buy-price'), weightEl = $('#buy-weight'), gauge = $('#buy-gauge');
    let cartG = 0;

    const sync = () => {
      const qty = Math.max(1, Number(qtyInput.value) || 1);
      priceEl.textContent = money(unitCents * qty);
      const kg = (unitG * qty) / 1000;
      weightEl.textContent = `${(kg / 0.45359237).toFixed(1)} lb (${kg.toFixed(2)} kg)`;
      if (gauge) renderGauge(gauge, cartG + unitG * qty);
    };
    getCart().then(c => { cartG = c.total_weight; sync(); }).catch(sync);

    qtyInput.addEventListener('input', sync);
    $$('[data-qty]', form).forEach(b => b.addEventListener('click', () => {
      qtyInput.value = Math.max(1, Math.min(99, (Number(qtyInput.value) || 1) + (b.dataset.qty === 'inc' ? 1 : -1)));
      sync();
    }));

    form.addEventListener('submit', e => {
      e.preventDefault();
      const qty = Math.max(1, Number(qtyInput.value) || 1);
      const btn = $('[type="submit"]', form); btn.disabled = true;
      addToCart(form.elements.id.value, qty)
        .then(() => getCart())
        .then(c => { cartG = c.total_weight; paintCount(c.item_count); sync(); toast(T('toast_added_qty', '{qty} × {name} added.', { qty, name: $('h1')?.textContent.trim() }), '/cart'); })
        .catch(err => toast(err.message))
        .finally(() => { btn.disabled = false; });
    });

    $$('[data-gallery-thumb]').forEach(btn => btn.addEventListener('click', () => {
      const main = $('#gallery-main');
      main.src = btn.dataset.galleryThumb; main.alt = btn.dataset.galleryAlt || '';
      const photo = btn.dataset.galleryPhoto;
      main.closest('.product-stage')?.classList.toggle('is-photo', !!photo);
      main.style.objectPosition = photo || '';
      $$('[data-gallery-thumb]').forEach(b => b.setAttribute('aria-current', String(b === btn)));
    }));
  }

  /* Add to Cart straight from a product card */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    addToCart(btn.dataset.add, 1)
      .then(() => getCart()).then(c => { paintCount(c.item_count); toast(T('toast_added', '{name} added.', { name: btn.dataset.name }), '/cart'); })
      .catch(err => toast(err.message))
      .finally(() => { btn.disabled = false; });
  });

  /* select_item for GA4 (via GTM). The Google & YouTube app already sends the rest of the
     ecommerce funnel; this is the one step it does not see. item_id matches the app's format. */
  document.addEventListener('click', e => {
    const card = e.target.closest('[data-card]');
    if (!card || e.target.closest('[data-add]') || !e.target.closest('a')) return;
    const list = card.closest('section')?.querySelector('h1, h2')?.textContent.trim() || document.title;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'fr_select_item',
      ecommerce: {
        item_list_name: list,
        items: [{
          item_id: card.dataset.itemId, item_name: card.dataset.name, item_brand: 'Franceschi Chocolate',
          item_category: card.dataset.type, item_variant: card.dataset.sku || undefined,
          price: Number(card.dataset.price) / 100, quantity: 1,
          index: [...card.parentElement.children].indexOf(card)
        }]
      }
    });
  });

  /* ---------------------------------------------------------- cart page --- */
  const SHIPPING = { freeFrom: 15000, flat: 1300 };   // cents — Shipping Policy, 18 Oct 2026
  function initCartPage() {
    const root = $('[data-cart]');
    if (!root) return;
    const gauge = $('#cart-gauge');
    getCart().then(c => {
      if (!c.item_count) return;
      const kg = c.total_weight / 1000;
      const state = gaugeState(kg);
      if (gauge) renderGauge(gauge, c.total_weight);
      $('#sum-weight').textContent = `${(kg / 0.45359237).toFixed(1)} lb (${kg.toFixed(1)} kg)`;
      /* Shipping estimate: kit-only orders ship free; otherwise free from $150 of merchandise, else $13 flat. */
      const kitOnly = c.items.every(i => i.product_type === 'Kit');
      const ship = kitOnly || c.items_subtotal_price >= SHIPPING.freeFrom ? 0 : SHIPPING.flat;
      $('#sum-shipping').textContent = ship === 0 ? T('ship_free', 'Free') : money(ship);
      const gap = SHIPPING.freeFrom - c.items_subtotal_price;
      $('#sum-shipping-note').textContent = ship > 0 && gap > 0
        ? T('ship_note_gap', 'Add {gap} more for free shipping (orders of {min} or more, continental US).', { gap: money(gap), min: money(SHIPPING.freeFrom) })
        : T('ship_note', 'Continental United States.');
      $('#sum-total').textContent = money(c.total_price + ship);
      /* Above the ceiling the primary action changes identity, not just wording. */
      if (state === 'bulk') {
        $('#cart-cta').innerHTML = `
          <a class="btn btn--block btn--lg" href="/pages/bulk-orders?from=cart#quote">${esc(T('bulk_cta', 'Continue as Bulk Order'))}</a>
          <p class="t-xs t-muted mt-4" style="text-align:center">${esc(T('bulk_carry', 'Your {count} items and {lb} lb ({kg} kg) carry over to the quote form.', { count: c.item_count, lb: (kg / 0.45359237).toFixed(1), kg: kg.toFixed(1) }))}</p>`;
        /* The cart crossed the online ceiling: checkout is replaced by a quote, so GA4 must see it. */
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'fr_bulk_threshold', cart_weight_lb: Math.round(kg / 0.45359237), value: c.items_subtotal_price / 100, currency: 'USD' });
      }
      $('#cart-live').textContent = T('cart_live', 'Cart updated. {count} items, {lb} pounds, subtotal {subtotal}.', { count: c.item_count, lb: (kg / 0.45359237).toFixed(1), subtotal: money(c.items_subtotal_price) });
    });
    /* quantity typed by hand: submit the cart form so the server recalculates */
    $$('input[name="updates[]"]', root).forEach(inp => inp.addEventListener('change', () => {
      const line = inp.dataset.line, qty = Math.max(1, Math.min(99, Number(inp.value) || 1));
      location.href = `/cart/change?line=${line}&quantity=${qty}`;
    }));
  }

  /* --------------------------------------------- bulk quote: cart carry-over --- */
  function initBulkForm() {
    const form = $('#bulk-form');
    if (!form) return;
    const weight = form.querySelector('[name="contact[Estimated weight per order (lb)]"]');
    const conv = $('#bulk-weight-conv');
    const paintConv = () => {
      if (!weight || !conv) return;
      const lb = Number(weight.value) || 0;
      conv.textContent = `${lb.toLocaleString('en-US')} lb (${(lb * 0.45359237).toFixed(lb * 0.45359237 < 10 ? 1 : 0)} kg)`;
    };
    weight?.addEventListener('input', paintConv);
    paintConv();
    if (new URLSearchParams(location.search).get('from') !== 'cart') return;
    getCart().then(c => {
      if (!c.item_count) return;
      const lb = Math.round(c.total_weight / 453.59237);
      const lines = c.items.map(i => T('bulk_line', '{title} — {qty} × {unit}', {
        title: i.product_title, qty: i.quantity,
        unit: i.product_type === 'Kit' ? T('unit_kit', 'kit') : T('unit_bag', '2 lb bag')
      }));
      const box = $('#bulk-inherited');
      if (box) {
        $('#bulk-inherited-list').innerHTML = lines.map(l => `<li>${esc(l)}</li>`).join('');
        $('#bulk-inherited-total').textContent = `${lb} lb (${Math.round(c.total_weight / 1000)} kg) · ${money(c.items_subtotal_price)}`;
        box.hidden = false;
      }
      const products = form.querySelector('[name="contact[Products required]"]');
      if (products && !products.value) products.value = lines.join('\n');
      if (weight && !weight.value) { weight.value = lb; paintConv(); }
    });
  }

  initReveal();
  initProductPage();
  initCartPage();
  initBulkForm();
})();
